import type { BusinessRevenue } from './types'

function filterBusinessRevenueByValue(list: BusinessRevenue[], text: string) {
  // The line below escapes regular expression special characters:
  // [ \ ^ $ . | ? * + ( )
  const escapedText = text.replace(/[-\\^$*+?.()|[\]{}]/g, '\\$&');

  // Create the regular expression with modified value which
  // handles escaping special characters. Without escaping special
  // characters, errors will appear in the console
  const exp = new RegExp(escapedText, 'i');
  return list.filter(o => exp.test(o));
}

export function buildBusinessRevenueList(locale: string, filter: string): BusinessRevenue[] {

  var businessRevenueList: BusinessRevenue[] = []

  return businessRevenueList =
    [
    '0 - 10,000 EUR',
    '10,001 - 20,000 EUR',
    '20,001 - 30,000 EUR',
    '30,001 - 40,000 EUR',
    '40,001 - 50,000 EUR',
    '50,001 - 60,000 EUR',
    '60,001 - 70,000 EUR',
    '70,001 - 80,000 EUR',
    '80,001 - 90,000 EUR',
    '90,001 - 100,000 EUR',
    '> 100,001 EUR ' 
    ]
}

